<template>
  <div class="header FTG-info-Menu" :class="{'about-team-menu': type === '3' || type === '6' || type === '7'}">
    <Layout>
      <Header>
        <Menu mode="horizontal" theme="dark" :active-name="type">
          <div class="layout-nav SelectNone">
            <MenuItem :to="{path: '/'}" name="2">Works</MenuItem>
            <MenuItem :to="{path: '/about'}" name="3">About</MenuItem>
            <!-- <MenuItem :to="{path: '/workflow'}" name="7">Workflow</MenuItem> -->
            <MenuItem :to="{path: '/team'}" name="6">Team</MenuItem>
            <MenuItem :to="{path: '/news'}" name="5">News</MenuItem>
            <MenuItem :to="{path: '/contact'}" name="4">Contact</MenuItem>
            <div class="links" style="position: relative;top: 18px;">
              <img src="../assets/image/footer-linkedin.png" @click="linkWeb('https://www.linkedin.com/in/fay-yu-b3659038/')" alt="logo" class="logo-dark">
              <img src="../assets/image/footer-architizer.jpg" @click="linkWeb('https://architizer.com/firms/ftg-studio/')" alt="logo" class="logo-dark">
            </div>
            <!-- <div class="Clear"></div> -->
          </div>

          <Icon @click="showMenu()" class="HeaderMenu" :class="{'darkHeaderMenu': type === '3' || type === '6' || type === '7'}" type="md-menu" />
        </Menu>
      </Header>
    </Layout>


    <Modal v-model="menuModal" class="MenuModal" :styles="{top: '0px'}">
      <Button @click.native="toPage('/')" :style="{borderBottom: '1px solid'}" class="singalBtn" type="text">Works</Button>
      <Button @click.native="toPage('/about')" :style="{borderBottom: '1px solid'}" class="singalBtn" type="text">About</Button>
      <!-- <Button @click.native="toPage('/workflow')" :style="{borderBottom: '1px solid'}" class="singalBtn" type="text">Workflow</Button> -->
      <Button @click.native="toPage('/team')" :style="{borderBottom: '1px solid'}" class="singalBtn" type="text">Team</Button>
      <Button @click.native="toPage('/news')" :style="{borderBottom: '1px solid'}" class="singalBtn" type="text">News</Button>
      <Button @click.native="toPage('/contact')" class="singalBtn" type="text">Contact</Button>
      <div class="links">
        <img src="../assets/image/footer-linkedin.png" @click="linkWeb('https://www.linkedin.com/in/fay-yu-b3659038/')" alt="logo" class="logo-dark">
        <img src="../assets/image/footer-architizer.jpg" @click="linkWeb('https://architizer.com/firms/ftg-studio/')" alt="logo" class="logo-dark">
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  props: ["type"],
  name: 'infoHeader',
  data () {
    return {
      menuModal: false
    }
  },
  methods: {
    showMenu(){
      this.menuModal = true
    },
    toPage(_path){
      this.$router.push({path: _path})
    },
    linkWeb(url){
      window.open(url, '_blank')
    },
  },
  mounted() {

  },
  watch:{
    
  }
}
</script>

<style scoped lang="less">
  @import './component.less';
</style>



// WEBPACK FOOTER //
// src/components/infoHeader.vue